/* eslint-disable no-param-reassign */
import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/tipos-de-recargo/';

/**
 * GET Tipos de Recargos
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeRecargos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Recargo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeRecargo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Tipo de Recargo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeRecargo = async (values) => {
  try {
    values.dias_de_gracia = values.dias_de_gracia || undefined;
    values.periodo = values.es_calculable_por_periodo ? values.periodo : undefined;
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Recargo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeRecargo = async (id, values) => {
  try {
    // values.dias_de_gracia = values.dias_de_gracia || undefined;
    values.periodo = values.es_calculable_por_periodo ? values.periodo : undefined;
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Recargo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeRecargo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
